import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import { Button, Message} from "semantic-ui-react";

import FormsInputsText from "../inputs/text/forms_inputs_text";
import FormsInputPassword from "../inputs/password/forms_inputs_password";
import { LoginSchema, LoginOTPSchema, UpdatePasswordSchema } from "./validate";
import ModalDialog from '../../widgets/modalDialog/ModalDialog';
import ReCAPTCHA from "react-google-recaptcha";
import CommonUtility from "../../../utils/CommonUtility";
class FormsLogin extends Component {
    state = {
        error: false,
        errorMessage: null,
        showLoginOTPScreen: false,
        showUpdatePasswordScreen: false,
        user: null,
        currentPassword: '',
        lockAccountModalVisible: false,
        errorTitle: '',
        robot_token: '',
        OTPtype: 'EMAIL',        
    };

    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry. {this.state.errorMessage}</Message.Header>
                </Message>
            );
        }
    }

    render() {
        return (
            <>
                {
                    this.state.showUpdatePasswordScreen ?
                    <Formik
                        initialValues={{ newPassword: "", newPasswordConfirm: "" }}
                        validateOnBlur={false}
                        validateOnChange={false}
                        validationSchema={UpdatePasswordSchema}
                        validate={(values) => {
                            let error = {};
                            if (values.newPassword !== values.newPasswordConfirm) {
                                error.newPasswordConfirm = 'New passwords do not match.';
                            } else if (!CommonUtility.isValidPasswordFormat(values.newPassword)) {
                                error.newPasswordConfirm = 'Password must have 8 digits containing at least 1 uppercase, 1 lowercase, 1 numbers, and 1 special characters. (Combination of those 3 is fine)';
                            }
                            return error;
                        }}
                        onSubmit={(values, actions) => {
                            this.setState({ error: false, errorMessage: "" });
                            this.props.updateUserProfileChangePassword({
                                data: {
                                    oldPassword: this.state.currentPassword,
                                    newPassword: values.newPassword,
                                    newPasswordConfirm: values.newPasswordConfirm
                                },
                                accessToken: this.state.user && this.state.user.accessToken
                            }, (result, error) => {
                                actions.setSubmitting(false);
                                if (error) {
                                    actions.resetForm();
                                    this.setState({
                                        error: true,
                                        errorTitle: "Update Password Failed",
                                        errorMessage: error.errorMessage || "Failed to update your password. Please try again."
                                    });
                                    return;
                                }
                                actions.resetForm();
                                this.setState({
                                    error: false,
                                    errorMessage: null,
                                    errorTitle: null,
                                    showUpdatePasswordScreen: false,
                                    user: null,
                                    currentPassword: ''
                                });
                            });
                        }}
                        render={({ isSubmitting }) => (
                            <Form className="ui form">
                                <Message warning>
                                    <Message.Header>Password Update Required</Message.Header>
                                    <p>
                                        For security reasons, please update your password before continuing.
                                    </p>
                                    <p>
                                        Your password must be at least 8 characters long, include a number, an uppercase letter and a lowercase letter.
                                    </p>
                                </Message>
                                <Field
                                    name="newPassword"
                                    label="New Password"
                                    component={FormsInputPassword}
                                    secondaryLabel="Input your new password"
                                />
                                <Field
                                    name="newPasswordConfirm"
                                    label="New Password Confirmation"
                                    component={FormsInputPassword}
                                    secondaryLabel="Input your new password again"
                                />
                                <div className="field">
                                    <Button id="submit-update-password" type="submit" primary disabled={isSubmitting} fluid loading={isSubmitting}>
                                        Update Password
                                    </Button>
                                </div>
                                <div className="field">
                                    <Button
                                        id="back-login-from-update-password"
                                        type="button"
                                        primary
                                        fluid
                                        onClick={() => {
                                            this.setState({
                                                error: false,
                                                errorMessage: null,
                                                errorTitle: null,
                                                showUpdatePasswordScreen: false,
                                                user: null,
                                                currentPassword: ''
                                            });
                                        }}>
                                        Back to Login Page
                                    </Button>
                                </div>
                                {this.renderFormSubmissionResult()}
                            </Form>
                        )}
                    />
                :
                    this.state.showLoginOTPScreen ?
                    <Formik
                       initialValues={{ otp: "" }}
                       onSubmit={(values, actions) => {
                           console.log(values, actions);
                           this.setState({ error: false, errorMessage: "" });
                           this.props.verifyLoginOTPEmail({nric: this.state.user.nric, otp: values.otp}, (result, error) => {
                               if (error) {
                                    actions.resetForm();
                                    this.setState({ error: true, errorMessage: error.errorMessage });
                                    return;
                                }


                                actions.setSubmitting(false);
                                this.setState({
                                    error: false,
                                    errorMessage: null,
                                    showLoginOTPScreen: false
                                });
                            });
                       }}
                       validateOnBlur={false}
                       validateOnChange={false}
                       validationSchema={LoginOTPSchema}
                       render={({ values, errors, status, touched, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
                            <Form className="ui form">
                                <Message positive>
                                    {this.state.OTPtype === 'EMAIL' ? 'Check your Email!' : 'Check your Phone!'}
                                    <p>
                                        An OTP verification has been sent to {this.state.user? this.state.OTPtype === 'EMAIL' ? this.state.user.email : "your registered phone number" : "your registered phone number"}.
                                    </p>
                                </Message>

                                <Field name="otp" label="One Time Password" component={FormsInputsText} secondaryLabel=""/>
                                <div className="field">
                                    <Button id="submit" type="submit" primary disabled={isSubmitting} fluid loading={isSubmitting}>
                                        Submit
                                    </Button>
                                </div>
                                <div className="field">
                                    <Button
                                        id="back-login"
                                        type="button"
                                        primary
                                        fluid
                                        onClick={() => {
                                            this.setState({
                                                error: false,
                                                errorMessage: null,
                                                showLoginOTPScreen: false
                                            })
                                        }}>
                                        Back to Login Page
                                    </Button>
                                </div>
                                {this.renderFormSubmissionResult()}
                            </Form>
                       )}
                    />
                :
                    <Formik
                        initialValues={{ email: "", password: "" }}
                        onSubmit={(values, actions) => {
                            var response = window.grecaptcha.getResponse();
                            console.log("response ", response)
                           // console.log(values, actions);
                            this.setState({ error: false, errorMessage: "" });
                            if(response == ''){
                                actions.setSubmitting(false);
                                this.setState({error: true, errorTitle: "Invalid Captcha", errorMessage: "Please verify your captcha"});
                            }else{
                                this.props.doLogin({...values, captchaResponse: response}, (result, error) => {
                                    console.log('doLogin-result', result);
                                    
                                    if(result && result.notifyUserLastPasswordUpdate === true){
                                        this.props.setRemindUpdatePassword(true);
                                    }
    
                                    if (error) {
                                        window.grecaptcha.reset();
                                        if (error.errorMessage && error.errorMessage.split('.')[0] === "Your account has been locked") {
                                            this.setState({
                                                lockAccountModalVisible: true
                                            })
                                        }
    
                                        actions.resetForm();
                                        this.setState({errorTitle:"Login Failed", error: true, errorMessage: error.errorMessage });
                                        return;
                                    }
                                    actions.setSubmitting(false);
                                    
                                    console.log('Login successful', result);
                                    this.setState({
                                        error: false,
                                        errorMessage: null,
                                        errorTitle: null,
                                        user: result.user,
                                        currentPassword: values.password,
                                        robot_token:''
                                    });

                                    // Force user to update password if status is 101
                                    if (result.user && result.user.status === 101) {
                                        this.setState({
                                            showUpdatePasswordScreen: true,
                                            showLoginOTPScreen: false
                                        });
                                        return;
                                    }
    
                                    if (!result.user.accessToken)
                                    {this.props.generateLoginOTPEmail({nric: result.user.nric}, (result, error)=>{
                                        // if (error) {
                                        //     this.setState({ errorTitle:"OTP Failed", error: true, errorMessage: error.errorMessage, showLoginOTPScreen: false });
                                        //     return;
                                        // } else {
                                            
                                        // }
                                    });}
                                    this.setState({
                                        OTPtype: result.OTPtype,
                                        showLoginOTPScreen: true,
                                    })
                                });
                            }
                            
                        }}
                        validateOnBlur={false}
                        validateOnChange={false}
                        validationSchema={LoginSchema}
                        render={({ values, errors, status, touched, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
                            <Form className="ui form">
                                <Field name="email" label="Email Address" component={FormsInputsText} secondaryLabel="" />
                                <Field name="password" label="Password" component={FormsInputPassword} secondaryLabel="" />
                                &nbsp;
                                <ReCAPTCHA 
                                    sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                    onChange={(value) => {
                                        if(value){
                                            this.setState({
                                                robot_token: value
                                            })
                                        }
                                    }}
                                />
                                &nbsp;
                                <Button type="submit" size="large" primary disabled={isSubmitting} fluid loading={isSubmitting}>
                                    Sign In
                                </Button>
                                {this.renderFormSubmissionResult()}
                            </Form>
                        )}
                    />
                }
                <ModalDialog
                    open={this.state.lockAccountModalVisible}
                    title={<p>Your Account Has Been Locked</p>} 
                    description={<p>To unlock your account, please recover your account</p>}
                    btnYesText="Ok"
                    btnNoText="Contact us instead"
                    btnYesAction={(function(){
                        this.setState({
                            lockAccountModalVisible: false
                        });
                        this.props.history.push('/recoveraccount');
                    }).bind(this)}
                    btnNoAction={function(){
                        this.setState({
                            lockAccountModalVisible: false
                        });
                    }.bind(this)}
                />
            </>
        );
    }
}

export default FormsLogin;
